import React from 'react'
import PropTypes from 'prop-types'

import { colorUtil } from '@app/util'

import './info-box.scss'

const SIZES = Object.freeze({
  SMALL: 'small',
  LARGE: 'large'
})
const SIZE_MAPPER = Object.freeze({
  small: 32,
  large: 40
})

export const ProgressCircle = ({ progress, colorfulProgress, size }) => {
  const sizeAsNumber = SIZE_MAPPER[size]
  const strokeWidth = 2
  const normalizedRadius = (sizeAsNumber / 2) - strokeWidth
  const circumference = normalizedRadius * 2 * Math.PI

  // No value → render just the empty grey ring (no arc, no number inside).
  const hasProgress = typeof progress === 'number' && !Number.isNaN(progress)
  const strokeDashoffset = hasProgress
    ? circumference - Math.min(progress, 100) / 100 * circumference
    : circumference

  const progressColor = colorfulProgress ? colorUtil.getProgressColor(progress) : '#0045FF'

  return (
    <div className='progress'>
      <svg
        height={sizeAsNumber}
        width={sizeAsNumber}
      >
        <circle
          stroke='#D5D5D9'
          fill='transparent'
          strokeWidth={strokeWidth}
          r={normalizedRadius}
          cx={sizeAsNumber / 2}
          cy={sizeAsNumber / 2}
        />
        {hasProgress && (
          <circle
            stroke={progressColor}
            fill='transparent'
            strokeWidth={strokeWidth}
            strokeDasharray={circumference + ' ' + circumference}
            style={{ strokeDashoffset }}
            r={normalizedRadius}
            cx={sizeAsNumber / 2}
            cy={sizeAsNumber / 2}
          />
        )}
      </svg>
      <div className={`progress-value ${size}`}>
        {hasProgress ? `${progress}%` : ''}
      </div>
    </div>
  )
}

ProgressCircle.propTypes = {
  progress: PropTypes.number,
  size: PropTypes.oneOf(Object.values(SIZES)).isRequired,
  colorfulProgress: PropTypes.bool
}
ProgressCircle.defaultProps = {
  colorfulProgress: false
}
